import { render, staticRenderFns } from "./LiveInfo.vue?vue&type=template&id=c0f96f9e&scoped=true"
import script from "./LiveInfo.vue?vue&type=script&lang=js"
export * from "./LiveInfo.vue?vue&type=script&lang=js"
import style0 from "./LiveInfo.vue?vue&type=style&index=0&id=c0f96f9e&prod&lang=scss"
import style1 from "./LiveInfo.vue?vue&type=style&index=1&id=c0f96f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f96f9e",
  null
  
)

export default component.exports